import difference from "lodash/difference";
import isEqual from "lodash/isEqual";
import { DecoratorsActions } from "stores/decorators/DecoratorsStore";
const DecoratorsUpdater = (newDecorators, oldDecorators) => {
  const newDecoratorIds = newDecorators.filter(({ id }) => id !== void 0).map(({ id }) => id).sort();
  const oldDecoratorIds = oldDecorators.map(({ id }) => id).sort();
  const oldDecoratorsById = oldDecorators.reduce((prev, cur) => cur.id ? { ...prev, [cur.id]: cur } : prev, {});
  const newDecoratorsById = newDecorators.reduce((prev, cur) => cur.id ? { ...prev, [cur.id]: cur } : prev, {});
  const createdDecorators = difference(newDecoratorIds, oldDecoratorIds).map(
    (newDecoratorId) => newDecoratorsById[newDecoratorId]
  );
  const updatedDecorators = newDecorators.filter(({ id }) => id).filter(
    (decorator) => decorator.id && oldDecoratorsById[decorator.id] && !isEqual(decorator, oldDecoratorsById[decorator.id])
  );
  const deletedDecoratorIds = difference(oldDecoratorIds, newDecoratorIds);
  return [
    ...createdDecorators.map(
      ({ id: _id, ...newDecorator }) => () => DecoratorsActions.create(newDecorator)
    ),
    ...updatedDecorators.map(
      (updatedDecorator) => () => DecoratorsActions.update(updatedDecorator.id, updatedDecorator)
    ),
    ...deletedDecoratorIds.map((deletedID) => () => DecoratorsActions.remove(deletedID))
  ].reduce((prev, cur) => prev.then(() => cur()), Promise.resolve());
};
export default DecoratorsUpdater;
